// AuthContext's `currentSubdomain` is only ever populated by fetchSubdomainInfo(),
// which only runs when the app itself is being viewed on a *.users.godreamx.com
// host -- never true while using the builder (app.godreamx.com or its Railway
// domain). So currentSubdomain is always null here.
//
// user.subdomain (from GET /api/auth/me) is the authoritative source -- it's
// the real Subdomain record's own fullDomain, so it's correct even when the
// org's name collided with another org's at signup and got a random numeric
// suffix (createOrgSubdomain() does this; a plain re-slugify of the org name
// then produces a DIFFERENT string than the real subdomain, silently
// publishing to the wrong place). Confirmed live in production: two orgs
// both named "Tyler's Company" slugify to the same "tylers-company", so the
// second one's real subdomain is "tylers-company-997" -- re-deriving it from
// the org name instead of reading it is exactly what broke that account.
//
// Slugifying the org name is now only a last-resort fallback for the brief
// window before user.subdomain has loaded, not the primary mechanism.
const slugify = (text) =>
  text.toLowerCase().trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');

export function deriveSubdomainSlug(user, currentSubdomain) {
  if (currentSubdomain?.name) return currentSubdomain.name;
  if (currentSubdomain?.fullDomain) return currentSubdomain.fullDomain.split('.')[0];
  const userSubdomain = user?.subdomain;
  if (userSubdomain) {
    if (typeof userSubdomain === 'string') return userSubdomain.split('.')[0];
    if (userSubdomain.fullDomain) return userSubdomain.fullDomain.split('.')[0];
  }
  if (user?.org) return typeof user.org === 'string' ? slugify(user.org) : slugify(user.org.name || '');
  return null;
}
